export default "__VITE_ASSET__Dem2XBDx__"